import { FC } from 'react'
import { Controller } from 'react-hook-form'

import Autocomplete from '@mui/material/Autocomplete'
import TextField, { StandardTextFieldProps } from '@mui/material/TextField'

interface BaseSelectAutocompleteProps extends Omit<StandardTextFieldProps, 'onChange' | 'value'> {
  control: any
  name: string
  label: string
  errors?: any
  options: string[]
}

const BaseSelectAutocomplete: FC<BaseSelectAutocompleteProps> = ({
  control,
  errors,
  name,
  label,
  options,
  sx,
  ...rest
}) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value, ref } }) => (
        <Autocomplete
          freeSolo
          options={options}
          value={value || ''}
          onChange={(_, newValue: string | null) => {
            onChange(newValue || '')
          }}
          onInputChange={(_, newInputValue: string) => {
            onChange(newInputValue)
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              {...rest}
              inputRef={ref}
              label={label}
              error={typeof errors === 'string' ? !!errors : !!errors?.[name]?.message}
              helperText={typeof errors === 'string' ? errors : errors?.[name]?.message}
              fullWidth
              sx={{ minHeight: '70px', height: 'fit-content', ...sx }}
            />
          )}
          sx={sx}
        />
      )}
    />
  )
}

export default BaseSelectAutocomplete

